// 判断当前url走什么埋点
export const getUrlGtm = (
    url: string,
    {
        product_name = '',
        list_name = '',
        button_name = '',
    }: {
        product_name: string;
        list_name: string;
        button_name: string;
    },
) => {
    if (!url) return {};
    if (url?.includes?.('${locale}.ecoflow.com/products/')) {
        return {
            event: 'uaEvent',
            event_name: 'buy',
            product_name,
            position: 'Header Navigation',
            display_type: 'none',
            module_referral: 'none',
            jump_module: 'none',
            url,
        };
    } else if (url?.includes?.('www.ecoflow.com')) {
        return {
            event: 'uaEvent',
            event_name: 'select_product',
            list_name,
            product_name,
            button_name,
        };
    } else {
        return {
            event: 'uaEvent',
            event_name: 'view_more',
            list_name,
            button_name,
        };
    }
};
